import WindowsReplacementMeasurementValues from './WindowsReplacementMeasurementValues';

export default WindowsReplacementMeasurementValues;